import { useRef } from 'react'
import { promiseVoidF, voidF } from 'types/FunctionTypes'

const initSubmit = async () => {}
let shift = false
let ctrl = false
let submited = false
export const useEnterKeyFocusControl = () => {
  const ref = useRef(new Map<number, HTMLInputElement>())

  return (
    index: number, //
    type: 'number' | 'text' | 'login',
    search: promiseVoidF = initSubmit,
    submit: voidF | promiseVoidF = initSubmit,
  ) => ({
    async onKeyDown(e: KeyboardEvent) {
      const key = e.key
      switch (key) {
        case 'Enter':
        case 'Tab':
          const aim = shift ? -1 : 1
          const sortedIndices = [...ref.current.keys()].sort()
          const nextIndex = sortedIndices[sortedIndices.indexOf(index) + aim]
          await submit()
          submited = true
          if (ctrl) {
            await search()
            return
          }
          // if (!(await submit(nextIndex))) return
          if (key === 'Tab') return
          if (typeof nextIndex === 'number') ref.current.get(nextIndex)?.focus()
          return
        case 'Shift':
          shift = true
          return
        case 'Control':
          ctrl = true
          return
        case 'CapsLock':
          if (type === 'login') {
            e.preventDefault()
          }
          return
        default:
          if (type === 'number') {
            if (key === 'e' || key === '+' || key === '-' || key === '.') e.preventDefault()
          }
          shift = false
          ctrl = false
          submited = false
          return
      }
    },
    async onKeyUp({ key }: { key: string }) {
      switch (key) {
        case 'Shift':
          shift = false
          return
        case 'Control':
          ctrl = false
          return
      }
    },
    async onBlur() {
      if (!submited) await submit()
    },
    ref(element: HTMLInputElement | null) {
      if (element) ref.current.set(index, element)
      else ref.current.delete(index)
    },
  })
}

export const useEnterKey = () => {
  return (submit: promiseVoidF = initSubmit) => ({
    async onKeyDown(e: KeyboardEvent) {
      const key = e.key
      switch (key) {
        case 'Enter':
        case 'Tab':
          await submit()
          return
      }
    },
    async onBlur() {
      await submit()
    },
  })
}
